// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/VanillaMilk.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./CodingCourseImages/portalBackground.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./CodingCourseImages/scratch.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./CodingCourseImages/appdev.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./CodingCourseImages/webdev.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./CodingCourseImages/gamedev.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./CodingCourseImages/php.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./CodingCourseImages/AI.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./CodingCourseImages/py.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("CodingCourseImages/courseroadmapbg.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face{

    font-family: 'VanillaMilk';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.CodingPortalBackground{
    width: 100%;
    height:600px;
    display: flex;
    background:  url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover; 
    position: relative;
    
}
.individual-course-img{
    /* width: 25vh;
    height: 21vh;  */
/* width: 100%;
height: 100%; */
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
}
.I-img1{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); 
}.I-img2{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); 
}.I-img3{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); 
}.I-img4{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); 
}.I-img5{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); 
}.I-img6{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___}); 
}.I-img7{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___}); 
}
.ind-course-title{
    font-size: medium;
    color: #8b0194;
    margin-left: 1rem;
  
}
.ind-course-border{
    border: 1px solid blue;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.CourseRoadMap
{
   background: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
   background-size: cover; 
    height: auto;
    width: 100%;
}
.CourseRoadMap div{
    display: flex;
    flex-direction: row; 
    align-items: center;
    justify-content: space-evenly;  
}
.CourseTabContent div
{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    text-align: center;
    width: 25vw;
    height: 100vh;
    padding: 0px 5vh 0 5vh;
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3); 

}
 .NoOfLesson
 {
    padding:1% 2% 1% 2%;
    font-size: lighter;
    color: white;
    border-radius: 1vh;
 }
 .RoadMapBullets
 {
    padding-top: 3vh;
    text-align: start;
    font-size: 2.4vh;
 }
.RequestCurriculumbtn
{
    color: white;
    font-size:medium;
    font-weight: bold;
    padding: 2% 4% 2% 4%;
    border-radius: 1vh;
}
.CourseRoadMapPara
{
    font-size: 2.4vh;
}

  #tb:hover {
    background-color: #d99fdd;
    font-weight: bold;
    color: #8b0194;
  }
#RoadMapTabs
{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    padding: 2%;
}
#RoadMapTabs div{
    /* background-color: #d99fdd; */
    border: 2px solid #8b0194;
    padding: 0.5% 1% 0.5% 1%;
    border-radius: 1vh;
    cursor: pointer;
}
#CourseTabContentDetails1
{
    height: 35%;
}
#CourseTabContentDetails2
{
    height: 65%;
}
@media only screen and (max-width: 1000px)
{
    .CodingPortalBackground{

        height: auto;
        width: auto;
    }
    .CourseRoadMap div
    {
        flex-direction: column;   
        padding: 1vh;
    }
    .CourseTabContent div
    {
        width: 100%;
        box-shadow: none;
        padding: 2%;
        height: -webkit-fill-available;
    }
    #RoadMapTabs {
        flex-direction: row;
    }
    #CourseTabContentDetails1,#CourseTabContentDetails2
    {
        height: -webkit-fill-available;
        width: -webkit-fill-available;
    }
}`, "",{"version":3,"sources":["webpack://./src/MyComponents/CodingPortal/CodingCourseDetails.css"],"names":[],"mappings":"AAAA;;IAEI,0BAA0B;IAC1B,4CAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,oDAA6D;IAC7D,sBAAsB;IACtB,kBAAkB;;AAEtB;AACA;IACI;oBACgB;AACpB;eACe;IACX,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;AAChC;AACA;IACI,yDAAyD;AAC7D,CAAC;IACG,yDAAwD;AAC5D,CAAC;IACG,yDAAwD;AAC5D,CAAC;IACG,yDAAyD;AAC7D,CAAC;IACG,yDAAqD;AACzD,CAAC;IACG,yDAAoD;AACxD,CAAC;IACG,yDAAoD;AACxD;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;;AAErB;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;;GAEG,mDAA0D;GAC1D,sBAAsB;IACrB,YAAY;IACZ,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;AACjC;AACA;;IAEI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,2CAA2C;;AAE/C;CACC;;IAEG,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;CACrB;CACA;;IAEG,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;CACnB;AACD;;IAEI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;AACtB;AACA;;IAEI,gBAAgB;AACpB;;EAEE;IACE,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;EAChB;AACF;;IAEI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;AACf;AACA;IACI,+BAA+B;IAC/B,yBAAyB;IACzB,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;AACnB;AACA;;IAEI,WAAW;AACf;AACA;;IAEI,WAAW;AACf;AACA;;IAEI;;QAEI,YAAY;QACZ,WAAW;IACf;IACA;;QAEI,sBAAsB;QACtB,YAAY;IAChB;IACA;;QAEI,WAAW;QACX,gBAAgB;QAChB,WAAW;QACX,8BAA8B;IAClC;IACA;QACI,mBAAmB;IACvB;IACA;;QAEI,8BAA8B;QAC9B,6BAA6B;IACjC;AACJ","sourcesContent":["@font-face{\n\n    font-family: 'VanillaMilk';\n    src: url('../fonts/VanillaMilk.otf');\n}\n\n.CodingPortalBackground{\n    width: 100%;\n    height:600px;\n    display: flex;\n    background:  url('./CodingCourseImages/portalBackground.png');\n    background-size: cover; \n    position: relative;\n    \n}\n.individual-course-img{\n    /* width: 25vh;\n    height: 21vh;  */\n/* width: 100%;\nheight: 100%; */\n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n}\n.I-img1{\n    background-image: url('./CodingCourseImages/scratch.png'); \n}.I-img2{\n    background-image: url('./CodingCourseImages/appdev.png'); \n}.I-img3{\n    background-image: url('./CodingCourseImages/webdev.png'); \n}.I-img4{\n    background-image: url('./CodingCourseImages/gamedev.png'); \n}.I-img5{\n    background-image: url('./CodingCourseImages/php.png'); \n}.I-img6{\n    background-image: url('./CodingCourseImages/AI.svg'); \n}.I-img7{\n    background-image: url('./CodingCourseImages/py.png'); \n}\n.ind-course-title{\n    font-size: medium;\n    color: #8b0194;\n    margin-left: 1rem;\n  \n}\n.ind-course-border{\n    border: 1px solid blue;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.CourseRoadMap\n{\n   background: url('CodingCourseImages/courseroadmapbg.jpeg');\n   background-size: cover; \n    height: auto;\n    width: 100%;\n}\n.CourseRoadMap div{\n    display: flex;\n    flex-direction: row; \n    align-items: center;\n    justify-content: space-evenly;  \n}\n.CourseTabContent div\n{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-evenly;\n    text-align: center;\n    width: 25vw;\n    height: 100vh;\n    padding: 0px 5vh 0 5vh;\n    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3); \n\n}\n .NoOfLesson\n {\n    padding:1% 2% 1% 2%;\n    font-size: lighter;\n    color: white;\n    border-radius: 1vh;\n }\n .RoadMapBullets\n {\n    padding-top: 3vh;\n    text-align: start;\n    font-size: 2.4vh;\n }\n.RequestCurriculumbtn\n{\n    color: white;\n    font-size:medium;\n    font-weight: bold;\n    padding: 2% 4% 2% 4%;\n    border-radius: 1vh;\n}\n.CourseRoadMapPara\n{\n    font-size: 2.4vh;\n}\n\n  #tb:hover {\n    background-color: #d99fdd;\n    font-weight: bold;\n    color: #8b0194;\n  }\n#RoadMapTabs\n{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-evenly;\n    padding: 2%;\n}\n#RoadMapTabs div{\n    /* background-color: #d99fdd; */\n    border: 2px solid #8b0194;\n    padding: 0.5% 1% 0.5% 1%;\n    border-radius: 1vh;\n    cursor: pointer;\n}\n#CourseTabContentDetails1\n{\n    height: 35%;\n}\n#CourseTabContentDetails2\n{\n    height: 65%;\n}\n@media only screen and (max-width: 1000px)\n{\n    .CodingPortalBackground{\n\n        height: auto;\n        width: auto;\n    }\n    .CourseRoadMap div\n    {\n        flex-direction: column;   \n        padding: 1vh;\n    }\n    .CourseTabContent div\n    {\n        width: 100%;\n        box-shadow: none;\n        padding: 2%;\n        height: -webkit-fill-available;\n    }\n    #RoadMapTabs {\n        flex-direction: row;\n    }\n    #CourseTabContentDetails1,#CourseTabContentDetails2\n    {\n        height: -webkit-fill-available;\n        width: -webkit-fill-available;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
